export default __webpack_public_path__ + "static/media/hygienekleidung.e7a53b1a.jpg";